import React from 'react';
import { Chip } from '@mui/material';
import { getRarityColor } from '../../utils/rarityUtils';

const RarityBadge = ({ rarity, size = 'medium', sx = {}, ...props }) => {
  const rarityColor = getRarityColor(rarity);

  return (
    <Chip
      label={rarity}
      size={size}
      sx={{
        width: 100,
        height: 24,
        borderRadius: 1,
        fontWeight: 600,
        fontSize: '0.8rem',
        justifyContent: 'center',
        color: rarityColor,
        border: `1px solid ${rarityColor}`,
        backgroundColor: `${rarityColor}22`,
        textTransform: 'capitalize',
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
          backgroundColor: `${rarityColor}22 !important`,
          transform: 'none !important',
          boxShadow: 'none !important'
        },
        '& .MuiChip-label': {
          px: 1.5,
          fontSize: '0.8rem',
          fontWeight: 600,
          whiteSpace: 'nowrap',
          overflow: 'visible',
          textOverflow: 'clip',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        ...sx,
      }}
      {...props}
    />
  );
};

export default RarityBadge;
